module.exports = __webpack_public_path__ + "img/Emotional_Health_Logo.2c715dce.png";